import type { NavbarItem } from "../Types/NavbarItem";
import type { LegacyBlazorNavVisibility } from "../Types/LegacyBlazorNavVisibility";

/** Client-level KPI module access (drawer KPI link + in-context Linked KPIs). */
export function canAccessClientKpi(
  visibility: LegacyBlazorNavVisibility | null,
  isClientAdmin: boolean
): boolean {
  if (!visibility) {
    return false;
  }
  return (
    visibility.showKpi &&
    (isClientAdmin || (visibility.showKpiEditor ?? visibility.showKpi))
  );
}

/**
 * Whether a classic-app drawer link should show, using server-side flags (Blazor MainLayout rules)
 * and Gen3 admin gating for legacy admin controls only.
 */
export function isLegacyDrawerItemVisible(
  item: NavbarItem,
  visibility: LegacyBlazorNavVisibility | null,
  isClientAdmin: boolean
): boolean {
  if (item.type !== "navigation") {
    return true;
  }

  if (item.id === 24) {
    return isClientAdmin;
  }

  if (!visibility) {
    return false;
  }

  switch (item.id) {
    case 1:
      return true;
    case 17:
      return visibility.showQualityCalendar;
    case 18:
      return canAccessClientKpi(visibility, isClientAdmin);
    case 19:
      return visibility.showLibrary;
    case 20:
      return visibility.showResources;
    case 21:
      return visibility.showNotifications;
    case 22:
      return visibility.showPartnerControls;
    case 23:
      return visibility.showDepartmentControls;
    default:
      return true;
  }
}
